import {ROUTER_DATA_LOAD_FULFILLED} from '../router/router-actions';
import {APP_RATING_LOAD_DATA} from './app-rating-actions';

export const initialState = () => ({isPending: false, data: null});

export default function appRating(state = initialState(), {type, payload}) {
    switch (type) {
        case `${APP_RATING_LOAD_DATA}_PENDING`: {
            return {...state, ...payload, isPending: true};
        }

        case `${APP_RATING_LOAD_DATA}_FULFILLED`: {
            return {...state, ...payload, isPending: false};
        }

        case ROUTER_DATA_LOAD_FULFILLED: {
            return payload.appRating || initialState();
        }

        default:
            return state;
    }
}
